import QuestionBox from "../ui/QuestionBox"

type DescriptionSectionProps = {
  descriptionOpen: boolean
  setDescriptionOpen: (value: boolean) => void
  description: string
  setDescription: (value: string) => void
}

export default function DescriptionSection({
  descriptionOpen,
  setDescriptionOpen,
  description,
  setDescription
}: DescriptionSectionProps) {
  const descriptionWordCount = description
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .length

  return (
    <div className="border-b-2 border-dashed border-gray-300 py-4">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => setDescriptionOpen(!descriptionOpen)}
          className={`relative h-8 w-16 rounded-full transition-colors ${
            descriptionOpen ? "bg-blue-800" : "bg-gray-400"
          }`}
        >
          <span
            className={`absolute left-1 top-1 h-6 w-6 rounded-full bg-white transition-transform ${
              descriptionOpen ? "translate-x-8" : "translate-x-0"
            }`}
          />
        </button>

        <h4 className="text-lg font-semibold text-blue-800">
          Description
        </h4>

        <QuestionBox title="Description">
          Under Article 1(2) of the EUDR, the application may include one single
          description per design of no more than 100 words explaining the
          representation of the design. The description may only refer to
          features visible in the representation of the design. It must not
          contain statements on the alleged novelty or individual character of
          the design or its technical value. If the description does not comply
          with the regulation, it will not be examined, but may be used by the
          examiner to clarify any doubts.
        </QuestionBox>
      </div>

      {descriptionOpen && (
        <div className="mt-5 rounded bg-gray-50 p-4">
          <label className="block text-sm text-gray-500">
            Add a short description to explain the design
          </label>

          <textarea
            value={description}
            onChange={(event) => {
              const words = event.target.value
                .trim()
                .split(/\s+/)
                .filter(Boolean)

              if (words.length <= 100) {
                setDescription(event.target.value)
              }
            }}
            className="mt-2 h-40 w-full resize-none rounded border-2 border-blue-800 px-3 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-800"
            placeholder="e.g. lorem ipsum..."
          />

          <div className="mt-3 inline-flex rounded-full bg-blue-50 px-3 py-2 text-xs font-semibold text-blue-800">
            {descriptionWordCount} / 100 words
          </div>
        </div>
      )}
    </div>
  )
}
